import '../../css/mobile/MDepChargePg.css';
import MHeader from "../../components/mobile/MHeader";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import axios from '../../services/axiosInstance';
import mainNotice from "../../assets/img/mainNotice.png";
import commonHeader from "../../assets/img/commonHeader.png";
import btoragePay from "../../assets/img/btorageBooster.png";
import globalCard from "../../assets/img/globalCard.png";
import koreanPay from "../../assets/img/koreanPay.png";
import paypal from "../../assets/img/3dPaypalLogo.png";
import wechatpay from "../../assets/img/3dWechatLogo.png";
import alipay from "../../assets/img/3dAlipayLogo.png";
import nobank from "../../assets/img/3dNoBankLogo.png";

import PaypalModal from "../../components/web/modal/PaypalModal";
import {useWebSocket} from "../../services/WebsocketContext";
import i18n from "../../i18n";
import withAuth from "../../auth/UserRouteAuth";
import BtorageGlobalModal from "../../components/web/modal/BtorageGlobalModal";
import btorageGlobalModal from "../../components/web/modal/BtorageGlobalModal";
import BtorageKoreanModal from "../../components/web/modal/BtorageKoreanModal";
import GlobalCardModal from "../../components/web/modal/GlobalCardModal";
import KoreanPayModal from "../../components/web/modal/KoreanPayModal";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";

const MDepChargePg = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [memberInfo, setMemberInfo] = useState("");
    const findMember = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberInfo(response.data)
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (SSAT || LCAT) {
            findMember();
        }
    }, [SSAT, LCAT])

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!memberInfo.mbNum || isSubscribedRef.current) return;
            if (!stompClient && !isConnected) {
                await websocketConnect(memberInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [memberInfo.mbNum, isConnected, stompClient]);

    const [submitBtDisabled, setSubmitBtDisabled] = useState(false);

    const [paypalTab, setPaypalTab] = useState(false);
    const [nobankTab, setNobankTab] = useState(false);
    const [yuanTab, setYuanTab] = useState(false);
    const [btorageGlobalTab, setBtorageGlobalTab] = useState(true);

    const [nobankChargeTab, setNobankChargeTab] = useState(true);
    const [nobankRefundTab, setNobankRefundTab] = useState(false);
    const [paypalChargeTab, setPaypalChargeTab] = useState(true);
    const [paypalRefundTab, setPaypalRefundTab] = useState(false);
    const [wechatChargeTab, setWechatChargeTab] = useState(true);
    const [wechatRefundTab, setWechatRefundTab] = useState(false);
    const [aliChargeTab, setAliChargeTab] = useState(true);
    const [aliRefundTab, setAliRefundTab] = useState(false);

    const [btorageGlobalChargeTab, setBtorageGlobalChargeTab] = useState(true);
    const [btorageGlobalRefundTab, setBtorageGlobalRefundTab] = useState(false);
    const [btorageKoreanChargeTab, setBtorageKoreanChargeTab] = useState(true);
    const [btorageKoreanRefundTab, setBtorageKoreanRefundTab] = useState(false);
    const [globalCardChargeTab, setGlobalCardChargeTab] = useState(true);
    const [globalCardRefundTab, setGlobalCardRefundTab] = useState(false);
    const [koreanPayChargeTab, setKoreanPayChargeTab] = useState(true);
    const [koreanPayRefundTab, setKoreanPayRefundTab] = useState(false);

    const handleMainTab = ((tab) => {
        if (tab === 'nobank') {
            setNobankTab(true);
            setPaypalTab(false);
            setYuanTab(false);
            setBtorageGlobalTab(false);
        } else if (tab === 'paypal') {
            setSelectedDollar('USD');
            setNobankTab(false);
            setPaypalTab(true);
            setYuanTab(false);
            setBtorageGlobalTab(false);
        } else if (tab === 'yuan') {
            setSelectedDollar('CNY');
            setNobankTab(false);
            setPaypalTab(false);
            setYuanTab(true);
            setBtorageGlobalTab(false);
        } else if (tab === 'btorageGlobal') {
            setSelectedDollar('USD');
            setNobankTab(false);
            setPaypalTab(false);
            setYuanTab(false);
            setBtorageGlobalTab(true);
        }
    });

    const handleBtorageGlobalAssiTab = ((tab) => {
        if (tab === 'charge') {
            setBtorageGlobalChargeTab(true);
            setBtorageGlobalRefundTab(false);
        } else {
            setBtorageGlobalChargeTab(false);
            setBtorageGlobalRefundTab(true);
        }
    });

    const handleBtorageKoreanAssiTab = ((tab) => {
        if (tab === 'charge') {
            setBtorageKoreanChargeTab(true);
            setBtorageKoreanRefundTab(false);
        } else {
            setBtorageKoreanChargeTab(false);
            setBtorageKoreanRefundTab(true);
        }
    });

    const handleGlobalCardAssiTab = ((tab) => {
        if (tab === 'charge') {
            setGlobalCardChargeTab(true);
            setGlobalCardRefundTab(false);
        } else {
            setGlobalCardChargeTab(false);
            setGlobalCardRefundTab(true);
        }
    });

    const handleKoreanPayAssiTab = ((tab) => {
        if (tab === 'charge') {
            setKoreanPayChargeTab(true);
            setKoreanPayRefundTab(false);
        } else {
            setKoreanPayChargeTab(false);
            setKoreanPayRefundTab(true);
        }
    });

    const handlePaypalAssiTab = ((tab) => {
        if (tab === "charge") {
            setPaypalChargeTab(true);
            setPaypalRefundTab(false);
        } else {
            setPaypalChargeTab(false);
            setPaypalRefundTab(true);
        }
    })

    const handleWechatAssiTab = ((tab) => {
        if (tab === "charge") {
            setWechatChargeTab(true);
            setWechatRefundTab(false);
        } else {
            setWechatChargeTab(false);
            setWechatRefundTab(true);
        }
    })

    const handleAliAssiTab = ((tab) => {
        if (tab === "charge") {
            setAliChargeTab(true);
            setAliRefundTab(false);
        } else {
            setAliChargeTab(false);
            setAliRefundTab(true);
        }
    })

    const handleNobankAssiTab = ((tab) => {
        if (tab === "charge") {
            setNobankChargeTab(true);
            setNobankRefundTab(false);
        } else {
            setNobankChargeTab(false);
            setNobankRefundTab(true);
        }
    })

    const btorageAccount = t(`dcMdMsg`);

    // 페이팔통화 셀렉트박스
    const paypalDollar = ['USD', 'CAD', 'AUD', 'NZD', 'EUR', 'JPY', 'SGD']
    const btorageDollar = ['USD', 'JPY']
    const [selectedDollar, setSelectedDollar] = useState('USD');


    const [dollarShow, setDollarShow] = useState(false);
    const dollarRef = useRef(null);

    const toggleDollarShow = () => {
        setDollarShow(!dollarShow);
    };

    const selectChangeDollar = (e) => {
        setSelectedDollar(e);
        setDollarShow(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dollarRef.current && !dollarRef.current.contains(event.target)) {
                setDollarShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const getTodayFormatted = () => {
        let date = new Date();
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let day = String(date.getDate()).padStart(2, '0');
        setNobankChargeSendDate(`${year}${month}${day}`);
        setWechatChargeSendDate(`${year}${month}${day}`);
        setAliChargeSendDate(`${year}${month}${day}`);
    };

    useEffect(() => {
        getTodayFormatted();
    }, []);

    const formatStringWithCommas = ((numberString) => {
        const numericString = numberString.replace(/[^\d]/g, '');
        return numericString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    })


    const [fieldEmptyError, setFieldEmptyError] = useState(false);
    const closeFieldEmptyError = () => {
        setFieldEmptyError(false);
    }

    // BtoragePay(Global) 충전
    const [btorageGlobalPopupSt, setBtorageGlobalPopupSt] = useState(false);
    const [btorageGlobalChargePrice, setBtorageGlobalChargePrice] = useState('');

    const closeBtorageGlobalPopup = (() => {
        setBtorageGlobalPopupSt(false);
    })

    const handleBtorageGlobalChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageGlobalChargePrice(formattedValue);
    })

    const openBtorageGlobalPopup = (() => {
        if (!btorageGlobalChargePrice) {
            setFieldEmptyError(true);
        } else {
            setBtorageGlobalPopupSt(true);
        }
    })

    const saveBtorageGlobalCharge = (() => {
        axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'BtoragePay(Global)',
                price: Number(btorageGlobalChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                currency: selectedDollar,
                dollarPrice: btorageGlobalChargeExPrice,
                autoPayFl: true,
                payMethod: '01'
            },
        })
            .then(async (response) => {
                setBtorageGlobalPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch((error) => {
                console.log("비토리지페이 충전실패 : ", error)
                setSubmitBtDisabled(false);
            })
    })

    const btorageGlobalChargeInit = (() => {
        setBtorageGlobalChargePrice('');
        setSelectedDollar('');
        setBtorageGlobalChargeExPrice(0);
    })


    // BtoragePay(Global) 환급
    const [btorageGlobalRefundPrice, setBtorageGlobalRefundPrice] = useState('');
    const [btorageGlobalRefundEmail, setBtorageGlobalRefundEmail] = useState('');

    const handleBtorageGlobalRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageGlobalRefundPrice(formattedValue);
    })
    const handleBtorageGlobalRefundEmail = ((e) => {
        setBtorageGlobalRefundEmail(e.target.value);
    })

    const saveBtorageGlobalRefund = (() => {
        if (submitBtDisabled) return;
        if (!btorageGlobalRefundPrice || !btorageGlobalRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: btorageGlobalRefundEmail,
                    price: Number(btorageGlobalRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: selectedDollar,
                    dollarPrice: btorageGlobalRefundExPrice,
                    autoPayFl: false,
                    payMethod: '02'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("비토리지페이(GL) 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const btorageGlobalRefundInit = (() => {
        setBtorageGlobalRefundPrice('');
        setBtorageGlobalRefundExPrice('');
        setBtorageGlobalRefundEmail('');
    })


    // BtoragePay(Korean) 충전
    const [btorageKoreanPopupSt, setBtorageKoreanPopupSt] = useState(false);
    const [btorageKoreanChargePrice, setBtorageKoreanChargePrice] = useState('');

    const closeBtorageKoreanPopup = (() => {
        setBtorageKoreanPopupSt(false);
    })

    const handleBtorageKoreanChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageKoreanChargePrice(formattedValue);
    })

    const openBtorageKoreanPopup = (() => {
        if (!btorageKoreanChargePrice) {
            setFieldEmptyError(true);
        } else {
            setBtorageKoreanPopupSt(true);
        }
    })

    const saveBtorageKoreanCharge = (() => {
        axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'BtoragePay(Korean)',
                price: Number(btorageKoreanChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                autoPayFl: true,
                payMethod: '03'
            },
        })
            .then(async (response) => {
                setBtorageKoreanPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch((error) => {
                console.log("비토리지페이 충전실패 : ", error)
                setSubmitBtDisabled(false);
            })
    })

    const btorageKoreanChargeInit = (() => {
        setBtorageKoreanChargePrice('');
        setSelectedDollar('');
    })


    // BtoragePay(Korean) 환급
    const [btorageKoreanRefundPrice, setBtorageKoreanRefundPrice] = useState('');
    const [btorageKoreanRefundEmail, setBtorageKoreanRefundEmail] = useState('');

    const handleBtorageKoreanRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageKoreanRefundPrice(formattedValue);
    })
    const handleBtorageKoreanRefundEmail = ((e) => {
        setBtorageKoreanRefundEmail(e.target.value);
    })

    const saveBtorageKoreanRefund = (() => {
        if (submitBtDisabled) return;
        if (!btorageKoreanRefundPrice || !btorageKoreanRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: btorageGlobalRefundEmail,
                    price: Number(btorageKoreanRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    autoPayFl: false,
                    payMethod: '04'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("비토리지페이(KR) 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const btorageKoreanRefundInit = (() => {
        setBtorageKoreanRefundPrice('');
        setBtorageKoreanRefundEmail('');
    })


    // GlobalCard 충전
    const [globalCardPopupSt, setGlobalCardPopupSt] = useState(false);
    const [globalCardChargePrice, setGlobalCardChargePrice] = useState('');

    const closeGlobalCardPopup = (() => {
        setGlobalCardPopupSt(false);
    })

    const handleGlobalCardChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setGlobalCardChargePrice(formattedValue);
    })

    const openGlobalCardPopup = (() => {
        if (!globalCardChargePrice) {
            setFieldEmptyError(true);
        } else {
            setGlobalCardPopupSt(true);
        }
    })

    const saveGlobalCardCharge = (() => {
        axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'GlobalCard',
                price: Number(globalCardChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                currency: selectedDollar,
                dollarPrice: globalCardChargeExPrice,
                autoPayFl: true,
                payMethod: '05'
            },
        })
            .then(async (response) => {
                setGlobalCardPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch((error) => {
                console.log("글로벌카드 충전실패 : ", error)
                setSubmitBtDisabled(false);
            })
    })

    const globalCardChargeInit = (() => {
        setGlobalCardChargePrice('');
        setSelectedDollar('');
        setGlobalCardChargeExPrice(0);
    })


    // GlobalCard 환급
    const [globalCardRefundPrice, setGlobalCardRefundPrice] = useState('');
    const [globalCardRefundEmail, setGlobalCardRefundEmail] = useState('');

    const handleGlobalCardRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setGlobalCardRefundPrice(formattedValue);
    })
    const handleGlobalCardRefundEmail = ((e) => {
        setGlobalCardRefundEmail(e.target.value);
    })

    const saveGlobalCardRefund = (() => {
        if (submitBtDisabled) return;
        if (!globalCardRefundPrice || !globalCardRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: globalCardRefundEmail,
                    price: Number(globalCardRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: selectedDollar,
                    dollarPrice: globalCardRefundExPrice,
                    autoPayFl: false,
                    payMethod: '06'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("글로벌카드 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const globalCardRefundInit = (() => {
        setGlobalCardRefundPrice('');
        setGlobalCardRefundExPrice('');
        setGlobalCardRefundEmail('');
    })


    // KoreanPay 충전
    const [koreanPayPopupSt, setKoreanPayPopupSt] = useState(false);
    const [koreanPayChargePrice, setKoreanPayChargePrice] = useState('');

    const closeKoreanPayPopup = (() => {
        setKoreanPayPopupSt(false);
    })

    const handleKoreanPayChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setKoreanPayChargePrice(formattedValue);
    })

    const openKoreanPayPopup = (() => {
        if (!koreanPayChargePrice) {
            setFieldEmptyError(true);
        } else {
            setKoreanPayPopupSt(true);
        }
    })

    const saveKoreanPayCharge = (() => {
        axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'KoreanPay',
                price: Number(koreanPayChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                autoPayFl: true,
                payMethod: '07'
            },
        })
            .then(async (response) => {
                setKoreanPayPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch((error) => {
                console.log("코리안페이 충전실패 : ", error)
                setSubmitBtDisabled(false);
            })
    })

    const koreanPayChargeInit = (() => {
        setKoreanPayChargePrice('');
        setSelectedDollar('');
    })


    // KoreanPay 환급
    const [koreanPayRefundPrice, setKoreanPayRefundPrice] = useState('');
    const [koreanPayRefundEmail, setKoreanPayRefundEmail] = useState('');

    const handleKoreanPayRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setKoreanPayRefundPrice(formattedValue);
    })
    const handleKoreanPayRefundEmail = ((e) => {
        setKoreanPayRefundEmail(e.target.value);
    })

    const saveKoreanPayRefund = (() => {
        if (submitBtDisabled) return;
        if (!koreanPayRefundPrice || !koreanPayRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: koreanPayRefundEmail,
                    price: Number(koreanPayRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    autoPayFl: false,
                    payMethod: '08'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("코리안페이 환불실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const koreanPayRefundInit = (() => {
        setKoreanPayRefundPrice('');
        setKoreanPayRefundEmail('');
    })


    // 페이팔충전
    const [paypalPopupSt, setPaypalPopupSt] = useState(false);
    const [paypalChargePrice, setPaypalChargePrice] = useState('');

    const paypalPopupClose = (() => {
        setPaypalPopupSt(false);
    })

    const handlePaypalChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setPaypalChargePrice(formattedValue);
    })

    const openPaypalPopup = (() => {
        if (!paypalChargePrice) {
            setFieldEmptyError(true);
        } else {
            setPaypalPopupSt(true);
        }
    })

    const savePaypalCharge = (() => {
        axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'Paypal',
                price: Number(paypalChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                currency: selectedDollar,
                dollarPrice: paypalChargeExPrice,
                autoPayFl: true,
                payMethod: '09'
            },
        })
            .then(async (response) => {
                setPaypalPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch((error) => {
                console.log("페이팔충전 실패 : ", error)
                setSubmitBtDisabled(false);
            })
    })

    const paypalChargeInit = (() => {
        setPaypalChargePrice('');
        setSelectedDollar('');
        setPaypalChargeExPrice('');
        setPaypalChargeExPrice(0);
    })


    // 페이팔환급
    const [paypalRefundPrice, setPaypalRefundPrice] = useState('');
    const [paypalRefundEmail, setPaypalRefundEmail] = useState('');

    const handlePaypalRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setPaypalRefundPrice(formattedValue);
    })
    const handlePaypalRefundEmail = ((e) => {
        setPaypalRefundEmail(e.target.value);
    })

    const savePaypalRefund = (() => {
        if (submitBtDisabled) return;
        if (!paypalRefundPrice || !paypalRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: paypalRefundEmail,
                    price: Number(paypalRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: selectedDollar,
                    dollarPrice: paypalRefundExPrice,
                    autoPayFl: false,
                    payMethod: '10'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("페이팔 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const paypalRefundInit = (() => {
        setPaypalRefundPrice('');
        setPaypalRefundExPrice('');
        setPaypalRefundEmail('');
    })


    // 위챗충전
    const [wechatChargePrice, setWechatChargePrice] = useState('');
    const [wechatChargeSendId, setWechatChargeSendId] = useState('');
    const [wechatChargeSendDate, setWechatChargeSendDate] = useState('');

    const handleWechatChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setWechatChargePrice(formattedValue);
    })
    const handleWechatChargeSendId = ((e) => {
        setWechatChargeSendId(e.target.value);
    })
    const handleWechatChargeSendDate = ((e) => {
        setWechatChargeSendDate(e.target.value);
    })

    const saveWechatCharge = (() => {
        if (submitBtDisabled) return;
        if (!wechatChargePrice || !wechatChargeSendId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: wechatChargeSendId,
                    account: btorageAccount,
                    price: Number(wechatChargePrice.replace(/,/g, "")),
                    chargeFl: true,
                    sendDate: wechatChargeSendDate,
                    status: '0',
                    currency: "CNY",
                    dollarPrice: wechatChargeExPrice,
                    autoPayFl: false,
                    payMethod: '11'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("위챗페이 충전실패")
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const wechatChargeInit = (() => {
        setWechatChargePrice('');
        setWechatChargeSendId('');
        setWechatChargeSendDate('');
    })

    // 위챗환급
    const [wechatRefundPrice, setWechatRefundPrice] = useState('');
    const [wechatRefundId, setWechatRefundId] = useState('');

    const handleWechatRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setWechatRefundPrice(formattedValue);
    })
    const handleWechatRefundId = ((e) => {
        setWechatRefundId(e.target.value);
    })

    const saveWechatRefund = (() => {
        if (submitBtDisabled) return;
        if (!wechatRefundPrice || !wechatRefundId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: wechatRefundId,
                    price: Number(wechatRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: "CNY",
                    dollarPrice: wechatRefundExPrice,
                    autoPayFl: false,
                    payMethod: '12'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("위챗페이 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const wechatRefundInit = (() => {
        setWechatRefundPrice('');
        setWechatRefundId('');
    })


    // 알리충전
    const [aliChargePrice, setAliChargePrice] = useState('');
    const [aliChargeSendId, setAliChargeSendId] = useState('');
    const [aliChargeSendDate, setAliChargeSendDate] = useState('');

    const handleAliChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setAliChargePrice(formattedValue);
    })
    const handleAliChargeSendId = ((e) => {
        setAliChargeSendId(e.target.value);
    })
    const handleAliChargeSendDate = ((e) => {
        setAliChargeSendDate(e.target.value);
    })

    const saveAliCharge = (() => {
        if (submitBtDisabled) return;
        if (!aliChargePrice || !aliChargeSendId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: aliChargeSendId,
                    account: btorageAccount,
                    price: Number(aliChargePrice.replace(/,/g, "")),
                    chargeFl: true,
                    sendDate: aliChargeSendDate,
                    status: '0',
                    currency: "CNY",
                    dollarPrice: aliChargeExPrice,
                    autoPayFl: false,
                    payMethod: '13'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("알리페이 충전실패")
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const aliChargeInit = (() => {
        setAliChargePrice('');
        setAliChargeSendId('');
        setAliChargeSendDate('');
    })

    // 알리환급
    const [aliRefundPrice, setAliRefundPrice] = useState('');
    const [aliRefundId, setAliRefundId] = useState('');

    const handleAliRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setAliRefundPrice(formattedValue);
    })
    const handleAliRefundId = ((e) => {
        setAliRefundId(e.target.value);
    })

    const saveAliRefund = (() => {
        if (submitBtDisabled) return;
        if (!aliRefundPrice || !aliRefundId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: aliRefundId,
                    price: Number(aliRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: "CNY",
                    dollarPrice: aliRefundExPrice,
                    autoPayFl: false,
                    payMethod: '14'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("알리페이 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const aliRefundInit = (() => {
        setAliRefundPrice('');
        setAliRefundId('');
    })


    // 무통장충전
    const [nobankChargePrice, setNobankChargePrice] = useState('');
    const [nobankChargeSendNm, setNobankChargeSendNm] = useState('');
    const [nobankChargeSendDate, setNobankChargeSendDate] = useState('');

    const handleNobankChargePrice = ((e) => {
        const {value} = e.target;
        const formattedValue = formatStringWithCommas(value);
        setNobankChargePrice(formattedValue);
    })
    const handleNobankChargeSendNm = ((e) => {
        setNobankChargeSendNm(e.target.value);
    })
    const handleNobankChargeSendDate = ((e) => {
        setNobankChargeSendDate(e.target.value);
    })

    const saveNobankCharge = (() => {
        if (submitBtDisabled) return;
        if (!nobankChargePrice || !nobankChargeSendNm) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: nobankChargeSendNm,
                    account: btorageAccount,
                    price: Number(nobankChargePrice.replace(/,/g, "")),
                    chargeFl: true,
                    sendDate: nobankChargeSendDate,
                    status: '0',
                    autoPayFl: false,
                    payMethod: '15'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("무통장입금 충전실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const nobankChargeInit = (() => {
        setNobankChargePrice('');
        setNobankChargeSendNm('');
        setNobankChargeSendDate('');
    })


    // 무통장환급
    const [nobankRefundPrice, setNobankRefundPrice] = useState('');
    const [nobankRefundNm, setNobankRefundNm] = useState('');
    const [nobankRefundBankNm, setNobankRefundBankNm] = useState('');
    const [nobankRefundAccount, setNobankRefundAccount] = useState('');

    const handleNobankRefundPrice = ((e) => {
        const {value} = e.target;
        const formattedValue = formatStringWithCommas(value);
        setNobankRefundPrice(formattedValue);
    })
    const handleNobankRefundNm = ((e) => {
        setNobankRefundNm(e.target.value);
    })
    const handleNobankRefundBankNm = ((e) => {
        setNobankRefundBankNm(e.target.value);
    })
    const handleNobankRefundAccount = ((e) => {
        setNobankRefundAccount(e.target.value);
    })

    const saveNobankRefund = (() => {
        if (submitBtDisabled) return;
        if (!nobankRefundPrice || !nobankRefundNm || !nobankRefundBankNm || !nobankRefundAccount) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: nobankRefundNm,
                    account: nobankRefundBankNm + nobankRefundAccount,
                    price: Number(nobankRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    status: '0',
                    autoPayFl: false,
                    payMethod: '16'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("무통장입금 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const nobankRefundInit = (() => {
        setNobankRefundPrice('');
        handleNobankRefundNm('');
        handleNobankRefundBankNm('');
        handleNobankRefundAccount('');
    })


    const formatNumber = (value) => {
        // 숫자 외의 모든 문자를 제거
        const number = value.replace(/[^\d]/g, "");
        // 세자리 수마다 콤마를 찍어서 반환
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const saveDepositAlarmData = ((depositData) => {
        axios({
            method: 'post',
            url: '/order/saveDepositData',
            headers: {
                Authorization: LCAT ? LCAT : SSAT,
                'Content-Type': 'application/json',
            },
            data: depositData
        })
            .then(async () => {
                await stompClient.send("/app/depConfirmAlarm", {}, JSON.stringify({sendFl: true}));
            })
            .catch((error) => {
                console.log("알림데이터 저장실패 : ", error)
            })
    })

    const [usdExrInfo, setUsdExrInfo] = useState([]);
    const [paypalChargeExPrice, setPaypalChargeExPrice] = useState(0);
    const [paypalRefundExPrice, setPaypalRefundExPrice] = useState(0);
    const [wechatChargeExPrice, setWechatChargeExPrice] = useState(0);
    const [wechatRefundExPrice, setWechatRefundExPrice] = useState(0);
    const [aliChargeExPrice, setAliChargeExPrice] = useState(0);
    const [aliRefundExPrice, setAliRefundExPrice] = useState(0);

    const [btorageGlobalChargeExPrice, setBtorageGlobalChargeExPrice] = useState(0);
    const [btorageGlobalRefundExPrice, setBtorageGlobalRefundExPrice] = useState(0);
    const [globalCardChargeExPrice, setGlobalCardChargeExPrice] = useState(0);
    const [globalCardRefundExPrice, setGlobalCardRefundExPrice] = useState(0);

    const selectedAllExrInfo = (() => {
        axios({
            method: 'get',
            url: '/paypal/selectedAllExrInfo/',
        })
            .then((response) => {
                setUsdExrInfo(response.data)
            })
            .catch(() => {
                console.log("환율조회실패")
            })
    })

    useEffect(() => {
        selectedAllExrInfo();
    }, [])

    const depositPayMethods = [
        {
            label: "Global",
            value: "btorageGlobal",
            logo: btoragePay,
        },
        {
            label: "Korean",
            value: "btorageKorean",
            logo: btoragePay,
        },
        {
            label: "GlobalCard",
            value: "globalCard",
            logo: globalCard,
        },
        {
            label: "KoreanPay",
            value: "koreanPay",
            logo: koreanPay,
        },
        {
            label: "Paypal",
            value: "paypal",
            logo: paypal,
        },
        {
            label: "WechatPay",
            value: "wechatpay",
            logo: wechatpay,
        },
        {
            label: "AliPay",
            value: "alipay",
            logo: alipay,
        },
        {
            label: "Remittance",
            value: "nobank",
            logo: nobank,
        },
    ];

    const [selected, setSelected] = useState(depositPayMethods[0]?.value);

    const handleSelect = (method) => {
        setSelected(method.value);
    };

    const calculateLastForPrice = () => {
        const btorageGlobalTab = selected === "btorageGlobal";
        const globalCardTab = selected === "globalCard";
        const paypalTab = selected === "paypal";
        const wechatpayTab = selected === "wechatpay";
        const alipayTab = selected === "alipay";

        // 1. 선택된 탭에 따라 기준 통화(Target Currency) 결정
        // 알리페이나 위챗페이일 경우 'CNY' 적용, 그 외에는 기존 selectedDollar 적용
        // (주의: 'CNY' 코드는 실제 usdExrInfo 데이터에 들어있는 위안화 코드에 맞게 수정하세요 예: 'RMB')
        const targetCurrency = (wechatpayTab || alipayTab) ? 'CNY' : selectedDollar;

        if (targetCurrency && usdExrInfo.length > 0) {
            // 2. usdExInfo 대신 동적으로 결정된 targetCurrency를 기준으로 환율 정보 탐색
            const targetExInfo = usdExrInfo.find(info => info.curPrice === targetCurrency);
            let numericFinalPayExpense;

            if (btorageGlobalTab && btorageGlobalChargeTab) {
                numericFinalPayExpense = parseFloat(btorageGlobalChargePrice.replace(/,/g, ''));
            } else if (btorageGlobalTab && btorageGlobalRefundTab) {
                numericFinalPayExpense = parseFloat(btorageGlobalRefundPrice.replace(/,/g, ''));
            } else if (globalCardTab && globalCardChargeTab) {
                numericFinalPayExpense = parseFloat(globalCardChargePrice.replace(/,/g, ''));
            } else if (globalCardTab && globalCardRefundTab) {
                numericFinalPayExpense = parseFloat(globalCardRefundPrice.replace(/,/g, ''));
            } else if (paypalTab && paypalChargeTab) {
                numericFinalPayExpense = parseFloat(paypalChargePrice.replace(/,/g, ''));
            } else if (paypalTab && paypalRefundTab) {
                numericFinalPayExpense = parseFloat(paypalRefundPrice.replace(/,/g, ''));
            } else if (wechatpayTab && wechatChargeTab) {
                numericFinalPayExpense = parseFloat(wechatChargePrice.replace(/,/g, ''));
            } else if (wechatpayTab && wechatRefundTab) {
                numericFinalPayExpense = parseFloat(wechatRefundPrice.replace(/,/g, ''));
            } else if (alipayTab && aliChargeTab) {
                numericFinalPayExpense = parseFloat(aliChargePrice.replace(/,/g, ''));
            } else if (alipayTab && aliRefundTab) {
                numericFinalPayExpense = parseFloat(aliRefundPrice.replace(/,/g, ''));
            }

            // 금액(50,000) / (환율(1333.14) - 요율(9.1%)) = 41.26usd
            // 3. usdExInfo 객체명들을 targetExInfo로 모두 교체
            if (!isNaN(numericFinalPayExpense) && targetExInfo) {
                const payRateAsRatio = targetExInfo.payRate / 100;
                const newLastForPrice = numericFinalPayExpense / (targetExInfo.payExr - (targetExInfo.payExr * payRateAsRatio));

                if (btorageGlobalTab && btorageGlobalChargeTab) {
                    setBtorageGlobalChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (btorageGlobalTab && btorageGlobalRefundTab) {
                    setBtorageGlobalRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (globalCardTab && globalCardChargeTab) {
                    setGlobalCardChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (globalCardTab && globalCardRefundTab) {
                    setGlobalCardRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (paypalTab && paypalChargeTab) {
                    setPaypalChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (paypalTab && paypalRefundTab) {
                    setPaypalRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (wechatpayTab && wechatChargeTab) {
                    setWechatChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (wechatpayTab && wechatRefundTab) {
                    setWechatRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (alipayTab && aliChargeTab) {
                    setAliChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (alipayTab && aliRefundTab) {
                    setAliRefundExPrice(Number(newLastForPrice.toFixed(2)));
                }
            }
        }
    }

    useEffect(() => {
        calculateLastForPrice();
    }, [
        selectedDollar,
        selected,
        usdExrInfo,
        btorageGlobalChargePrice, btorageGlobalRefundPrice,
        globalCardChargePrice, globalCardRefundPrice,
        paypalChargePrice, paypalRefundPrice,
        wechatChargePrice, wechatRefundPrice,
        aliChargePrice, aliRefundPrice
    ]);


    const currentLanguage = i18n.language || 'ko';
    const moveToPaypalFaq = (() => {
        let seqNum;
        switch (currentLanguage) {
            case 'en':
                seqNum = "53"
                break;
            case 'ja':
                seqNum = "54"
                break;
            case 'zh':
                seqNum = "55"
                break;
            case 'id':
                seqNum = "56"
                break;
            default:
                seqNum = "52"
        }
        navigate(`/UserFaqDtPg/${seqNum}`)
    })

    const moveToYuanFaq = (() => {
        let seqNum = '52'
        switch (currentLanguage) {
            case 'en':
                seqNum = "96"
                break;
            case 'ja':
                seqNum = "97"
                break;
            case 'zh':
                seqNum = "98"
                break;
            case 'id':
                seqNum = "99"
                break;
            default:
                seqNum = "95"
        }
        navigate(`/UserFaqDtPg/${seqNum}`)
    })






    return (
        <div className="m-a-dep-charg-pg-container font-t-cont">
            <MHeader title={t(`dcHeader`)} url={"/"}/>
            <div className={'m-a-dep-charg-pg-top'}>
                <div className='m-a-dep-charg-sub-title'>
                    <img className='m-a-dep-charg-sub-title-icon' src={commonHeader} alt=''/>
                    <p className="font-t-title font-s-15 p-t-5"> {t(`dcHeader`)}</p> {/*예치금신청*/}
                </div>
                <div className={'m-a-dep-charg-pg-top-right'}
                     onClick={() => navigate("/UserDepChargeHistoryPg")}> {t('dcHistory')}</div>
                {/*신청내역*/}
            </div>
            <div className={'m-a-dep-charg-pg-divider'}/>

            {/*상단 결제수단버튼*/}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "12px",
                    padding: "12px 0",
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                {depositPayMethods.map((method) => (
                    <div
                        key={method.value}
                        onClick={() => handleSelect(method)}
                        style={{
                            background: "#fff",
                            border: selected === method.value ? "2px solid darkorange" : "1px solid #E0E0E0",
                            borderRadius: 10,
                            boxShadow: selected === method.value ? "0 0 8px #1e90ff33" : "none",
                            transition: "border 0.2s, box-shadow 0.2s",
                            padding: "8px 0",
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            minWidth: 0,
                        }}
                    >
                        <div
                            style={{
                                width: 32,
                                height: 32,
                                background: "#F8F8F8",
                                borderRadius: 7,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: 4,
                            }}
                        >
                            <img
                                src={method.logo}
                                alt={method.label}
                                style={{
                                    width: 24,
                                    height: 24,
                                    objectFit: "contain",
                                    borderRadius: 5,
                                }}
                            />
                        </div>
                        <span
                            style={{
                                fontSize: 13,
                                fontWeight: selected === method.value ? 600 : 400,
                                color: selected === method.value ? "darkorange" : "#444",
                                textAlign: "center",
                            }}
                        >
                        {method.label}
                    </span>
                    </div>
                ))}
            </div>

            <div className="m-a-dep-charg-pg-bottom-frame">
                {
                    selected === "btorageGlobal" ?
                        <div className={'m-a-dep-charg-pg-binary-selector'}>
                            <div
                                className={`m-a-dep-charg-pg-binary-selector-item ${btorageGlobalChargeTab && 'selected'}`}
                                onClick={() => handleBtorageGlobalAssiTab('charge')}>{t(`st8`)}</div>
                            <div
                                className={`m-a-dep-charg-pg-binary-selector-item ${btorageGlobalRefundTab && 'selected'}`}
                                onClick={() => handleBtorageGlobalAssiTab('refund')}>{t(`st9`)}</div>
                        </div>
                        : selected === "btorageKorean" ?
                            <div className={'m-a-dep-charg-pg-binary-selector'}>
                                <div
                                    className={`m-a-dep-charg-pg-binary-selector-item ${btorageKoreanChargeTab && 'selected'}`}
                                    onClick={() => handleBtorageKoreanAssiTab('charge')}>{t(`st8`)}</div>
                                <div
                                    className={`m-a-dep-charg-pg-binary-selector-item ${btorageKoreanRefundTab && 'selected'}`}
                                    onClick={() => handleBtorageKoreanAssiTab('refund')}>{t(`st9`)}</div>
                            </div>
                            : selected === "globalCard" ?
                                <div className={'m-a-dep-charg-pg-binary-selector'}>
                                    <div
                                        className={`m-a-dep-charg-pg-binary-selector-item ${globalCardChargeTab && 'selected'}`}
                                        onClick={() => handleGlobalCardAssiTab('charge')}>{t(`st8`)}</div>
                                    <div
                                        className={`m-a-dep-charg-pg-binary-selector-item ${globalCardRefundTab && 'selected'}`}
                                        onClick={() => handleGlobalCardAssiTab('refund')}>{t(`st9`)}</div>
                                </div>
                                : selected === "koreanPay" ?
                                    <div className={'m-a-dep-charg-pg-binary-selector'}>
                                        <div
                                            className={`m-a-dep-charg-pg-binary-selector-item ${koreanPayChargeTab && 'selected'}`}
                                            onClick={() => handleKoreanPayAssiTab('charge')}>{t(`st8`)}</div>
                                        <div
                                            className={`m-a-dep-charg-pg-binary-selector-item ${koreanPayRefundTab && 'selected'}`}
                                            onClick={() => handleKoreanPayAssiTab('refund')}>{t(`st9`)}</div>
                                    </div>
                                    : selected === "paypal" ?
                                        <div className={'m-a-dep-charg-pg-binary-selector'}>
                                            <div
                                                className={`m-a-dep-charg-pg-binary-selector-item ${paypalChargeTab && 'selected'}`}
                                                onClick={() => handlePaypalAssiTab('charge')}>{t(`st8`)}</div>
                                            <div
                                                className={`m-a-dep-charg-pg-binary-selector-item ${paypalRefundTab && 'selected'}`}
                                                onClick={() => handlePaypalAssiTab('refund')}>{t(`st9`)}</div>
                                        </div>
                                        : selected === "wechatpay" ?
                                            <div className={'m-a-dep-charg-pg-binary-selector'}>
                                                <div
                                                    className={`m-a-dep-charg-pg-binary-selector-item ${wechatChargeTab && 'selected'}`}
                                                    onClick={() => handleWechatAssiTab('charge')}>{t(`st8`)}</div>
                                                <div
                                                    className={`m-a-dep-charg-pg-binary-selector-item ${wechatRefundTab && 'selected'}`}
                                                    onClick={() => handleWechatAssiTab('refund')}>{t(`st9`)}</div>
                                            </div>
                                            : selected === "alipay" ?
                                                <div className={'m-a-dep-charg-pg-binary-selector'}>
                                                    <div
                                                        className={`m-a-dep-charg-pg-binary-selector-item ${aliChargeTab && 'selected'}`}
                                                        onClick={() => handleAliAssiTab('charge')}>{t(`st8`)}</div>
                                                    <div
                                                        className={`m-a-dep-charg-pg-binary-selector-item ${aliRefundTab && 'selected'}`}
                                                        onClick={() => handleAliAssiTab('refund')}>{t(`st9`)}</div>
                                                </div>
                                                : selected === "nobank" ?
                                                    <div className={'m-a-dep-charg-pg-binary-selector'}>
                                                        <div
                                                            className={`m-a-dep-charg-pg-binary-selector-item ${nobankChargeTab && 'selected'}`}
                                                            onClick={() => handleNobankAssiTab('charge')}>{t(`st8`)}</div>
                                                        <div
                                                            className={`m-a-dep-charg-pg-binary-selector-item ${nobankRefundTab && 'selected'}`}
                                                            onClick={() => handleNobankAssiTab('refund')}>{t(`st9`)}</div>
                                                    </div>
                                                    :
                                                    null}

                {
                    // BtorageGlobal 충전탭
                    selected === "btorageGlobal" && btorageGlobalChargeTab ? (
                            <div className="m-a-dep-charg-pg-table-frame">
                                <div className="m-a-dep-charg-pg-table">
                                    <div className="m-a-dep-charg-pg-table-row">
                                        <div className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                        <div className={'m-a-dep-charg-pg-table-item'}>
                                            &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </div>
                                    </div>
                                    <div className={'m-a-dep-charg-pg-table-row'}>
                                        <div className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                        <input className={'m-a-dep-charg-pg-table-input'} maxLength={25} type="tel"
                                               onChange={handleBtorageGlobalChargePrice} value={btorageGlobalChargePrice}
                                               inputMode={"numeric"} pattern={"[0-9]*"}/>
                                    </div>
                                    <div className={'m-a-dep-charg-pg-table-row'}>
                                        <div className={'m-a-dep-charg-pg-table-item label'}>
                                            {t(`modExr`)}
                                            <div className={'m-a-dep-charg-pg-table-item-unit'} ref={dollarRef}
                                                 onClick={toggleDollarShow}>
                                                {selectedDollar}
                                                {dollarShow && (
                                                    <div className={'m-a-dep-charg-pg-table-dollar-list'}>
                                                        {btorageDollar.map((dollar, index) => (
                                                            <div
                                                                className={`m-a-dep-charg-pg-table-dollar-item ${selectedDollar === dollar && 'selected'}`}
                                                                key={index}
                                                                onClick={() => selectChangeDollar(dollar)}>
                                                                {dollar}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className={'m-a-dep-charg-pg-table-input'}>
                                            {Number(btorageGlobalChargePrice.replace(/,/g, "")) > 0 ? btorageGlobalChargeExPrice : null}
                                        </div>
                                    </div>
                                </div>
                                <div className={'m-a-dep-charg-pg-buttons'}>
                                    <div className={'m-a-dep-charg-pg-button-outline'}
                                         onClick={btorageGlobalChargeInit}>{t(`dcInitBt`)}</div>
                                    <div className={'m-a-dep-charg-pg-button-fill'}
                                         onClick={openBtorageGlobalPopup}>{t(`dcPayBt`)}</div>
                                </div>
                            </div>
                        ) :
                        // BtorageGlobal 환급탭
                        selected === "btorageGlobal" && btorageGlobalRefundTab ? (
                                <div className="m-a-dep-charg-pg-table-frame">
                                    <div className={'m-a-dep-charg-pg-table'}>
                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                            <div className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                            <div className={'m-a-dep-charg-pg-table-item'}>
                                                &#8361; {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </div>
                                        </div>
                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                            <div className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                            <input className={'m-a-dep-charg-pg-table-input'} maxLength={25} type="tel"
                                                   onChange={handleBtorageGlobalRefundPrice}
                                                   value={btorageGlobalRefundPrice} inputMode={"numeric"}
                                                   pattern={"[0-9]*"}/>
                                        </div>
                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                            <div className={'m-a-dep-charg-pg-table-item label'}>
                                                {t(`modExr`)}
                                                <div className={'m-a-dep-charg-pg-table-item-unit'} ref={dollarRef}
                                                     onClick={toggleDollarShow}>
                                                    {selectedDollar}
                                                    {dollarShow && (
                                                        <div className={'m-a-dep-charg-pg-table-dollar-list'}>
                                                            {btorageDollar.map((dollar, index) => (
                                                                <div
                                                                    className={`m-a-dep-charg-pg-table-dollar-item ${selectedDollar === dollar && 'selected'}`}
                                                                    key={index}
                                                                    onClick={() => selectChangeDollar(dollar)}>
                                                                    {dollar}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className={'m-a-dep-charg-pg-table-input'}>
                                                {Number(btorageGlobalRefundPrice.replace(/,/g, "")) > 0 ? btorageGlobalRefundExPrice : null}
                                            </div>
                                        </div>
                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                            <div className={'m-a-dep-charg-pg-table-item label'}>{t(`joinLabel1`)}</div>
                                            <input className={'m-a-dep-charg-pg-table-input'} maxLength={50} type="text"
                                                   onChange={handleBtorageGlobalRefundEmail}
                                                   value={btorageGlobalRefundEmail}/>
                                        </div>
                                    </div>
                                    <div className={'m-a-dep-charg-pg-buttons'}>
                                        <div className={'m-a-dep-charg-pg-button-outline'}
                                             onClick={btorageGlobalRefundInit}>{t(`dcInitBt`)}</div>
                                        <div className={'m-a-dep-charg-pg-button-fill'}
                                             onClick={saveBtorageGlobalRefund}
                                             style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                        </div>
                                    </div>
                                </div>
                            ) :
                            // BtorageKorean 충전탭
                            selected === "btorageKorean" && btorageKoreanChargeTab ? (
                                    <div className="m-a-dep-charg-pg-table-frame">
                                        <div className="m-a-dep-charg-pg-table">
                                            <div className="m-a-dep-charg-pg-table-row">
                                                <div className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                <div className={'m-a-dep-charg-pg-table-item'}>
                                                    &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </div>
                                            </div>
                                            <div className={'m-a-dep-charg-pg-table-row'}>
                                                <div className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                                <input className={'m-a-dep-charg-pg-table-input'} maxLength={25} type="tel"
                                                       onChange={handleBtorageKoreanChargePrice}
                                                       value={btorageKoreanChargePrice}
                                                       inputMode={"numeric"} pattern={"[0-9]*"}/>
                                            </div>
                                        </div>
                                        <div className={'m-a-dep-charg-pg-buttons'}>
                                            <div className={'m-a-dep-charg-pg-button-outline'}
                                                 onClick={btorageKoreanChargeInit}>{t(`dcInitBt`)}</div>
                                            <div className={'m-a-dep-charg-pg-button-fill'}
                                                 onClick={openBtorageKoreanPopup}>{t(`dcPayBt`)}</div>
                                        </div>
                                    </div>
                                ) :
                                // BtorageKorean 환급탭
                                selected === "btorageKorean" && btorageKoreanRefundTab ? (
                                        <div className="m-a-dep-charg-pg-table-frame">
                                            <div className={'m-a-dep-charg-pg-table'}>
                                                <div className={'m-a-dep-charg-pg-table-row'}>
                                                    <div className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                    <div className={'m-a-dep-charg-pg-table-item'}>
                                                        &#8361; {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                                <div className={'m-a-dep-charg-pg-table-row'}>
                                                    <div className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                                    <input className={'m-a-dep-charg-pg-table-input'} maxLength={25}
                                                           type="tel"
                                                           onChange={handleBtorageKoreanRefundPrice}
                                                           value={btorageKoreanRefundPrice} inputMode={"numeric"}
                                                           pattern={"[0-9]*"}/>
                                                </div>
                                                <div className={'m-a-dep-charg-pg-table-row'}>
                                                    <div
                                                        className={'m-a-dep-charg-pg-table-item label'}>{t(`joinLabel1`)}</div>
                                                    <input className={'m-a-dep-charg-pg-table-input'} maxLength={50}
                                                           type="text"
                                                           onChange={handleBtorageKoreanRefundEmail}
                                                           value={btorageKoreanRefundEmail}/>
                                                </div>
                                            </div>
                                            <div className={'m-a-dep-charg-pg-buttons'}>
                                                <div className={'m-a-dep-charg-pg-button-outline'}
                                                     onClick={btorageKoreanRefundInit}>{t(`dcInitBt`)}</div>
                                                <div className={'m-a-dep-charg-pg-button-fill'}
                                                     onClick={saveBtorageKoreanRefund}
                                                     style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                </div>
                                            </div>
                                        </div>
                                    ) :
                                    // GlobalCard 충전탭
                                    selected === "globalCard" && globalCardChargeTab ? (
                                            <div className="m-a-dep-charg-pg-table-frame">
                                                <div className="m-a-dep-charg-pg-table">
                                                    <div className="m-a-dep-charg-pg-table-row">
                                                        <div
                                                            className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                        <div className={'m-a-dep-charg-pg-table-item'}>
                                                            &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                        </div>
                                                    </div>
                                                    <div className={'m-a-dep-charg-pg-table-row'}>
                                                        <div
                                                            className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                                        <input className={'m-a-dep-charg-pg-table-input'} maxLength={25}
                                                               type="tel"
                                                               onChange={handleGlobalCardChargePrice}
                                                               value={globalCardChargePrice}
                                                               inputMode={"numeric"} pattern={"[0-9]*"}/>
                                                    </div>
                                                    <div className={'m-a-dep-charg-pg-table-row'}>
                                                        <div className={'m-a-dep-charg-pg-table-item label'}>
                                                            {t(`modExr`)}
                                                            <div className={'m-a-dep-charg-pg-table-item-unit'}
                                                                 ref={dollarRef}
                                                                 onClick={toggleDollarShow}>
                                                                {selectedDollar}
                                                                {dollarShow && (
                                                                    <div className={'m-a-dep-charg-pg-table-dollar-list'}>
                                                                        {btorageDollar.map((dollar, index) => (
                                                                            <div
                                                                                className={`m-a-dep-charg-pg-table-dollar-item ${selectedDollar === dollar && 'selected'}`}
                                                                                key={index}
                                                                                onClick={() => selectChangeDollar(dollar)}>
                                                                                {dollar}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className={'m-a-dep-charg-pg-table-input'}>
                                                            {Number(globalCardChargePrice.replace(/,/g, "")) > 0 ? globalCardChargeExPrice : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={'m-a-dep-charg-pg-buttons'}>
                                                    <div className={'m-a-dep-charg-pg-button-outline'}
                                                         onClick={globalCardChargeInit}>{t(`dcInitBt`)}</div>
                                                    <div className={'m-a-dep-charg-pg-button-fill'}
                                                         onClick={openGlobalCardPopup}>{t(`dcPayBt`)}</div>
                                                </div>
                                            </div>
                                        ) :
                                        // GlobalCard 환급탭
                                        selected === "globalCard" && globalCardRefundTab ? (
                                                <div className="m-a-dep-charg-pg-table-frame">
                                                    <div className={'m-a-dep-charg-pg-table'}>
                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                            <div
                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                            <div className={'m-a-dep-charg-pg-table-item'}>
                                                                &#8361; {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                            </div>
                                                        </div>
                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                            <div
                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                                            <input className={'m-a-dep-charg-pg-table-input'} maxLength={25}
                                                                   type="tel"
                                                                   onChange={handleGlobalCardRefundPrice}
                                                                   value={globalCardRefundPrice} inputMode={"numeric"}
                                                                   pattern={"[0-9]*"}/>
                                                        </div>
                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                            <div className={'m-a-dep-charg-pg-table-item label'}>
                                                                {t(`modExr`)}
                                                                <div className={'m-a-dep-charg-pg-table-item-unit'}
                                                                     ref={dollarRef}
                                                                     onClick={toggleDollarShow}>
                                                                    {selectedDollar}
                                                                    {dollarShow && (
                                                                        <div
                                                                            className={'m-a-dep-charg-pg-table-dollar-list'}>
                                                                            {btorageDollar.map((dollar, index) => (
                                                                                <div
                                                                                    className={`m-a-dep-charg-pg-table-dollar-item ${selectedDollar === dollar && 'selected'}`}
                                                                                    key={index}
                                                                                    onClick={() => selectChangeDollar(dollar)}>
                                                                                    {dollar}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className={'m-a-dep-charg-pg-table-input'}>
                                                                {Number(globalCardRefundPrice.replace(/,/g, "")) > 0 ? globalCardRefundExPrice : null}
                                                            </div>
                                                        </div>
                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                            <div
                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`joinLabel1`)}</div>
                                                            <input className={'m-a-dep-charg-pg-table-input'} maxLength={50}
                                                                   type="text"
                                                                   onChange={handleGlobalCardRefundEmail}
                                                                   value={globalCardRefundEmail}/>
                                                        </div>
                                                    </div>
                                                    <div className={'m-a-dep-charg-pg-buttons'}>
                                                        <div className={'m-a-dep-charg-pg-button-outline'}
                                                             onClick={globalCardRefundInit}>{t(`dcInitBt`)}</div>
                                                        <div className={'m-a-dep-charg-pg-button-fill'}
                                                             onClick={saveGlobalCardRefund}
                                                             style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) :
                                            // KoreanPay 충전탭
                                            selected === "koreanPay" && koreanPayChargeTab ? (
                                                    <div className="m-a-dep-charg-pg-table-frame">
                                                        <div className="m-a-dep-charg-pg-table">
                                                            <div className="m-a-dep-charg-pg-table-row">
                                                                <div
                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                <div className={'m-a-dep-charg-pg-table-item'}>
                                                                    &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                </div>
                                                            </div>
                                                            <div className={'m-a-dep-charg-pg-table-row'}>
                                                                <div
                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                                                <input className={'m-a-dep-charg-pg-table-input'}
                                                                       maxLength={25} type="tel"
                                                                       onChange={handleKoreanPayChargePrice}
                                                                       value={koreanPayChargePrice}
                                                                       inputMode={"numeric"} pattern={"[0-9]*"}/>
                                                            </div>
                                                        </div>
                                                        <div className={'m-a-dep-charg-pg-buttons'}>
                                                            <div className={'m-a-dep-charg-pg-button-outline'}
                                                                 onClick={koreanPayChargeInit}>{t(`dcInitBt`)}</div>
                                                            <div className={'m-a-dep-charg-pg-button-fill'}
                                                                 onClick={openKoreanPayPopup}>{t(`dcPayBt`)}</div>
                                                        </div>
                                                    </div>
                                                ) :
                                                // KoreanPay 환급탭
                                                selected === "koreanPay" && koreanPayRefundTab ? (
                                                        <div className="m-a-dep-charg-pg-table-frame">
                                                            <div className={'m-a-dep-charg-pg-table'}>
                                                                <div className={'m-a-dep-charg-pg-table-row'}>
                                                                    <div
                                                                        className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                    <div className={'m-a-dep-charg-pg-table-item'}>
                                                                        &#8361; {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                    </div>
                                                                </div>
                                                                <div className={'m-a-dep-charg-pg-table-row'}>
                                                                    <div
                                                                        className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                                                    <input className={'m-a-dep-charg-pg-table-input'}
                                                                           maxLength={25} type="tel"
                                                                           onChange={handleKoreanPayRefundPrice}
                                                                           value={koreanPayRefundPrice}
                                                                           inputMode={"numeric"} pattern={"[0-9]*"}/>
                                                                </div>
                                                                <div className={'m-a-dep-charg-pg-table-row'}>
                                                                    <div
                                                                        className={'m-a-dep-charg-pg-table-item label'}>{t(`joinLabel1`)}</div>
                                                                    <input className={'m-a-dep-charg-pg-table-input'}
                                                                           maxLength={50} type="text"
                                                                           onChange={handleKoreanPayRefundEmail}
                                                                           value={koreanPayRefundEmail}/>
                                                                </div>
                                                            </div>
                                                            <div className={'m-a-dep-charg-pg-buttons'}>
                                                                <div className={'m-a-dep-charg-pg-button-outline'}
                                                                     onClick={koreanPayRefundInit}>{t(`dcInitBt`)}</div>
                                                                <div className={'m-a-dep-charg-pg-button-fill'}
                                                                     onClick={saveKoreanPayRefund}
                                                                     style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) :
                                                    // Paypal 충전탭
                                                    selected === "paypal" && paypalChargeTab ? (
                                                            <div className="m-a-dep-charg-pg-table-frame">
                                                                <div className="m-a-dep-charg-pg-table">
                                                                    <div className="m-a-dep-charg-pg-table-row">
                                                                        <div
                                                                            className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                        <div className={'m-a-dep-charg-pg-table-item'}>
                                                                            &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                        </div>
                                                                    </div>
                                                                    <div className={'m-a-dep-charg-pg-table-row'}>
                                                                        <div
                                                                            className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                                                        <input className={'m-a-dep-charg-pg-table-input'}
                                                                               maxLength={25} type="tel"
                                                                               onChange={handlePaypalChargePrice}
                                                                               value={paypalChargePrice}
                                                                               inputMode={"numeric"} pattern={"[0-9]*"}/>
                                                                    </div>
                                                                    <div className={'m-a-dep-charg-pg-table-row'}>
                                                                        <div
                                                                            className={'m-a-dep-charg-pg-table-item label'}>
                                                                            {t(`pmHeader2`)}
                                                                            <div
                                                                                className={'m-a-dep-charg-pg-table-item-unit'}
                                                                                ref={dollarRef}
                                                                                onClick={toggleDollarShow}>
                                                                                {selectedDollar}
                                                                                {dollarShow && (
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-dollar-list'}>
                                                                                        {paypalDollar.map((dollar, index) => (
                                                                                            <div
                                                                                                className={`m-a-dep-charg-pg-table-dollar-item ${selectedDollar === dollar && 'selected'}`}
                                                                                                key={index}
                                                                                                onClick={() => selectChangeDollar(dollar)}>
                                                                                                {dollar}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className={'m-a-dep-charg-pg-table-input'}>
                                                                            {Number(paypalChargePrice.replace(/,/g, "")) > 0 ? paypalChargeExPrice : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={'m-a-dep-charg-pg-notice'}>
                                                                    <div className='m-a-dep-charg-sub-title'>
                                                                        <img className='m-a-dep-charg-sub-title-icon'
                                                                             src={mainNotice} alt=''/>
                                                                        <div
                                                                            className='m-a-dep-charg-sub-title-text'>{t('dcTx4')}</div>
                                                                    </div>
                                                                    <div className={'m-a-dep-charg-pg-notice-text-box'}>
                                                                        - {t(`dcTx1`)} &nbsp;
                                                                        <div onClick={moveToPaypalFaq}
                                                                             className={'m-a-dep-charg-pg-notice-text highlight'}>
                                                                            [{t(`dcTx2`)}]
                                                                        </div>
                                                                        {t(`dcTx3`)} <br/>
                                                                        - {t(`dcTx6`)}
                                                                    </div>
                                                                </div>
                                                                <div className={'m-a-dep-charg-pg-buttons'}>
                                                                    <div className={'m-a-dep-charg-pg-button-outline'}
                                                                         onClick={paypalChargeInit}>{t(`dcInitBt`)}</div>
                                                                    <div className={'m-a-dep-charg-pg-button-fill'}
                                                                         onClick={openPaypalPopup}>{t(`dcPayBt`)}</div>
                                                                </div>
                                                            </div>
                                                        ) :
                                                        // Paypal 환급탭
                                                        selected === "paypal" && paypalRefundTab ? (
                                                                <div className="m-a-dep-charg-pg-table-frame">
                                                                    <div className={'m-a-dep-charg-pg-table'}>
                                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                                            <div
                                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                            <div className={'m-a-dep-charg-pg-table-item'}>
                                                                                &#8361; {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                            </div>
                                                                        </div>
                                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                                            <div
                                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                                                            <input
                                                                                className={'m-a-dep-charg-pg-table-input'}
                                                                                maxLength={25} type="tel"
                                                                                onChange={handlePaypalRefundPrice}
                                                                                value={paypalRefundPrice}
                                                                                inputMode={"numeric"} pattern={"[0-9]*"}/>
                                                                        </div>
                                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                                            <div
                                                                                className={'m-a-dep-charg-pg-table-item label'}>
                                                                                {t(`pmHeader2`)}
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-item-unit'}
                                                                                    ref={dollarRef}
                                                                                    onClick={toggleDollarShow}>
                                                                                    {selectedDollar}
                                                                                    {dollarShow && (
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-dollar-list'}>
                                                                                            {paypalDollar.map((dollar, index) => (
                                                                                                <div
                                                                                                    className={`m-a-dep-charg-pg-table-dollar-item ${selectedDollar === dollar && 'selected'}`}
                                                                                                    key={index}
                                                                                                    onClick={() => selectChangeDollar(dollar)}>
                                                                                                    {dollar}
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className={'m-a-dep-charg-pg-table-input'}>
                                                                                {Number(paypalRefundPrice.replace(/,/g, "")) > 0 ? paypalRefundExPrice : null}
                                                                            </div>
                                                                        </div>
                                                                        <div className={'m-a-dep-charg-pg-table-row'}>
                                                                            <div
                                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`dcPpMail`)}</div>
                                                                            <input
                                                                                className={'m-a-dep-charg-pg-table-input'}
                                                                                maxLength={50} type="text"
                                                                                onChange={handlePaypalRefundEmail}
                                                                                value={paypalRefundEmail}/>
                                                                        </div>
                                                                    </div>
                                                                    <div className={'m-a-dep-charg-pg-notice'}>
                                                                        <div className='m-a-dep-charg-sub-title'>
                                                                            <img className='m-a-dep-charg-sub-title-icon'
                                                                                 src={mainNotice} alt=''/>
                                                                            <div
                                                                                className='m-a-dep-charg-sub-title-text'>{t(`dcTx4`)}</div>
                                                                        </div>
                                                                        <div className={'m-a-dep-charg-pg-notice-text-box'}>
                                                                            - {t(`dcTx5`)} <br/>
                                                                            - {t(`dcTx6`)}
                                                                        </div>
                                                                    </div>
                                                                    <div className={'m-a-dep-charg-pg-buttons'}>
                                                                        <div className={'m-a-dep-charg-pg-button-outline'}
                                                                             onClick={paypalRefundInit}>{t(`dcInitBt`)}</div>
                                                                        <div className={'m-a-dep-charg-pg-button-fill'}
                                                                             onClick={savePaypalRefund}
                                                                             style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) :
                                                            // wechatpay 충전탭
                                                            selected === "wechatpay" && wechatChargeTab ? (
                                                                    <div className="m-a-dep-charg-pg-table-frame">
                                                                        <div className={'m-a-dep-charg-pg-table'}>
                                                                            <div className={'m-a-dep-charg-pg-table-row'}>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-item'}>
                                                                                    &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                </div>
                                                                            </div>
                                                                            <div className={'m-a-dep-charg-pg-table-row'}>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                                                                <input
                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                    maxLength={25} type="tel"
                                                                                    onChange={handleWechatChargePrice}
                                                                                    value={wechatChargePrice}
                                                                                    inputMode={"numeric"}
                                                                                    pattern={"[0-9]*"}/>
                                                                            </div>
                                                                            <div className={'m-a-dep-charg-pg-table-row'}>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-item label'}>
                                                                                    {t(`dcTx7`)}(CNY)
                                                                                </div>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-input'}>
                                                                                    {Number(wechatChargePrice.replace(/,/g, "")) > 0 ? wechatChargeExPrice : null}
                                                                                </div>
                                                                            </div>
                                                                            <div className={'m-a-dep-charg-pg-table-row'}>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-item label'}>
                                                                                    {t(`dcTx8`)}ID
                                                                                </div>
                                                                                <input
                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                    maxLength={25} type="text"
                                                                                    placeholder={'Wechat ID'}
                                                                                    onChange={handleWechatChargeSendId}
                                                                                    value={wechatChargeSendId}/>
                                                                            </div>
                                                                            <div className={'m-a-dep-charg-pg-table-row'}>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-item label'}>
                                                                                    {t(`dcTx9`)}
                                                                                </div>
                                                                                <input
                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                    maxLength={8} type="tel"
                                                                                    onChange={handleWechatChargeSendDate}
                                                                                    value={wechatChargeSendDate}
                                                                                    inputMode={"numeric"}
                                                                                    pattern={"[0-9]*"}/>
                                                                            </div>
                                                                        </div>
                                                                        <div className={'m-a-dep-charg-pg-notice'}>
                                                                            <div className='m-a-dep-charg-sub-title'>
                                                                                <img
                                                                                    className='m-a-dep-charg-sub-title-icon'
                                                                                    src={mainNotice} alt=''/>
                                                                                <div
                                                                                    className='m-a-dep-charg-sub-title-text'>{t('dcTx4')}</div>
                                                                            </div>
                                                                            <div
                                                                                className={'m-a-dep-charg-pg-notice-text-box'}>
                                                                                - {t(`dcTx10`)} &nbsp;
                                                                                <div onClick={moveToYuanFaq}
                                                                                     className={'m-a-dep-charg-pg-notice-text highlight'}>[{t(`dcTx11`)}]
                                                                                </div>
                                                                                {t(`dcTx3`)}
                                                                            </div>
                                                                        </div>
                                                                        <div className={'m-a-dep-charg-pg-buttons'}>
                                                                            <div
                                                                                className={'m-a-dep-charg-pg-button-outline'}
                                                                                onClick={wechatChargeInit}>{t(`dcInitBt`)}</div>
                                                                            <div className={'m-a-dep-charg-pg-button-fill'}
                                                                                 onClick={saveWechatCharge}
                                                                                 style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ) :
                                                                // wechatpay 환급탭
                                                                selected === "wechatpay" && wechatRefundTab ? (
                                                                        <div className="m-a-dep-charg-pg-table-frame">
                                                                            <div className={'m-a-dep-charg-pg-table'}>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-row'}>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-item'}>
                                                                                        &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-row'}>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                                                                    <input
                                                                                        className={'m-a-dep-charg-pg-table-input'}
                                                                                        maxLength={25} type="tel"
                                                                                        onChange={handleWechatRefundPrice}
                                                                                        value={wechatRefundPrice}
                                                                                        inputMode={"numeric"}
                                                                                        pattern={"[0-9]*"}/>
                                                                                </div>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-row'}>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-item label'}>
                                                                                        {t(`dcTx7`)}(cny)
                                                                                    </div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-input'}>
                                                                                        {Number(wechatRefundPrice.replace(/,/g, "")) > 0 ? wechatRefundExPrice : null}
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-table-row'}>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-item label'}>{t(`dcTx12`)}ID
                                                                                    </div>
                                                                                    <input
                                                                                        className={'m-a-dep-charg-pg-table-input'}
                                                                                        maxLength={25} type="text"
                                                                                        onChange={handleWechatRefundId}
                                                                                        value={wechatRefundId}/>
                                                                                </div>
                                                                            </div>
                                                                            <div className={'m-a-dep-charg-pg-buttons'}>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-button-outline'}
                                                                                    onClick={wechatRefundInit}>{t(`dcInitBt`)}</div>
                                                                                <div
                                                                                    className={'m-a-dep-charg-pg-button-fill'}
                                                                                    onClick={saveWechatRefund}
                                                                                    style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) :
                                                                    // alipay 충전탭
                                                                    selected === "alipay" && aliChargeTab ? (
                                                                            <div className="m-a-dep-charg-pg-table-frame">
                                                                                <div className={'m-a-dep-charg-pg-table'}>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-row'}>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-item'}>
                                                                                            &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-row'}>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                                                                        <input
                                                                                            className={'m-a-dep-charg-pg-table-input'}
                                                                                            maxLength={25} type="tel"
                                                                                            onChange={handleAliChargePrice}
                                                                                            value={aliChargePrice}
                                                                                            inputMode={"numeric"}
                                                                                            pattern={"[0-9]*"}/>
                                                                                    </div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-row'}>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-item label'}>
                                                                                            {t(`dcTx7`)}(CNY)
                                                                                        </div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-input'}>
                                                                                            {Number(aliChargePrice.replace(/,/g, "")) > 0 ? aliChargeExPrice : null}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-row'}>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-item label'}>
                                                                                            {t(`dcTx8`)}ID
                                                                                        </div>
                                                                                        <input
                                                                                            className={'m-a-dep-charg-pg-table-input'}
                                                                                            maxLength={25} type="text"
                                                                                            placeholder={'Alipay ID'}
                                                                                            onChange={handleAliChargeSendId}
                                                                                            value={aliChargeSendId}/>
                                                                                    </div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table-row'}>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-item label'}>
                                                                                            {t(`dcTx9`)}
                                                                                        </div>
                                                                                        <input
                                                                                            className={'m-a-dep-charg-pg-table-input'}
                                                                                            maxLength={8} type="tel"
                                                                                            onChange={handleAliChargeSendDate}
                                                                                            value={aliChargeSendDate}
                                                                                            inputMode={"numeric"}
                                                                                            pattern={"[0-9]*"}/>
                                                                                    </div>
                                                                                </div>
                                                                                <div className={'m-a-dep-charg-pg-notice'}>
                                                                                    <div
                                                                                        className='m-a-dep-charg-sub-title'>
                                                                                        <img
                                                                                            className='m-a-dep-charg-sub-title-icon'
                                                                                            src={mainNotice} alt=''/>
                                                                                        <div
                                                                                            className='m-a-dep-charg-sub-title-text'>{t('dcTx4')}</div>
                                                                                    </div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-notice-text-box'}>
                                                                                        - {t(`dcTx10`)} &nbsp;
                                                                                        <div onClick={moveToYuanFaq}
                                                                                             className={'m-a-dep-charg-pg-notice-text highlight'}>[{t(`dcTx11`)}]
                                                                                        </div>
                                                                                        {t(`dcTx3`)}
                                                                                    </div>
                                                                                </div>
                                                                                <div className={'m-a-dep-charg-pg-buttons'}>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-button-outline'}
                                                                                        onClick={aliChargeInit}>{t(`dcInitBt`)}</div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-button-fill'}
                                                                                        onClick={saveAliCharge}
                                                                                        style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) :
                                                                        // alipay 환급탭
                                                                        selected === "alipay" && aliRefundTab ? (
                                                                                <div
                                                                                    className="m-a-dep-charg-pg-table-frame">
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-table'}>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-row'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-item'}>
                                                                                                &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-row'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                                                                            <input
                                                                                                className={'m-a-dep-charg-pg-table-input'}
                                                                                                maxLength={25} type="tel"
                                                                                                onChange={handleAliRefundPrice}
                                                                                                value={aliRefundPrice}
                                                                                                inputMode={"numeric"}
                                                                                                pattern={"[0-9]*"}/>
                                                                                        </div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-row'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-item label'}>
                                                                                                {t(`dcTx7`)}(cny)
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-input'}>
                                                                                                {Number(aliRefundPrice.replace(/,/g, "")) > 0 ? aliRefundExPrice : null}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table-row'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-item label'}>{t(`dcTx12`)}ID
                                                                                            </div>
                                                                                            <input
                                                                                                className={'m-a-dep-charg-pg-table-input'}
                                                                                                maxLength={25} type="text"
                                                                                                onChange={handleAliRefundId}
                                                                                                value={aliRefundId}/>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className={'m-a-dep-charg-pg-buttons'}>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-button-outline'}
                                                                                            onClick={aliRefundInit}>{t(`dcInitBt`)}</div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-button-fill'}
                                                                                            onClick={saveAliRefund}
                                                                                            style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) :
                                                                            // 무통장입금 충전탭
                                                                            selected === "nobank" && nobankChargeTab ? (
                                                                                    <div
                                                                                        className="m-a-dep-charg-pg-table-frame">
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item'}>&#8361; {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcDepPr`)}</div>
                                                                                                <input
                                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                                    maxLength={25}
                                                                                                    type="tel"
                                                                                                    onChange={handleNobankChargePrice}
                                                                                                    value={nobankChargePrice}
                                                                                                    inputMode={"numeric"}
                                                                                                    pattern={"[0-9]*"}/>
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcSd`)}</div>
                                                                                                <input
                                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                                    maxLength={35}
                                                                                                    type="text"
                                                                                                    onChange={handleNobankChargeSendNm}
                                                                                                    value={nobankChargeSendNm}/>
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcSdDate`)}</div>
                                                                                                <input
                                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                                    maxLength={8} type="tel"
                                                                                                    onChange={handleNobankChargeSendDate}
                                                                                                    value={nobankChargeSendDate}
                                                                                                    inputMode={"numeric"}
                                                                                                    pattern={"[0-9]*"}/>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-buttons'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-button-outline'}
                                                                                                onClick={nobankChargeInit}>{t(`dcInitBt`)}</div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-button-fill'}
                                                                                                onClick={saveNobankCharge}
                                                                                                style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) :
                                                                                // 무통장입금 환급탭
                                                                                selected === "nobank" && nobankRefundTab ? (
                                                                                    <div
                                                                                        className="m-a-dep-charg-pg-table-frame">
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-table'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`myBal`)}</div>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item'}>
                                                                                                    &#8361;  {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcRfPr`)}</div>
                                                                                                <input
                                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                                    maxLength={25}
                                                                                                    type="tel"
                                                                                                    onChange={handleNobankRefundPrice}
                                                                                                    value={nobankRefundPrice}
                                                                                                    inputMode={"numeric"}
                                                                                                    pattern={"[0-9]*"}/>
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>
                                                                                                    {t(`modNbInfo3`)}
                                                                                                </div>
                                                                                                <input
                                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                                    maxLength={35}
                                                                                                    type="text"
                                                                                                    onChange={handleNobankRefundNm}
                                                                                                    value={nobankRefundNm}/>
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcBkNm`)}</div>
                                                                                                <input
                                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                                    maxLength={25}
                                                                                                    type="text"
                                                                                                    onChange={handleNobankRefundBankNm}
                                                                                                    value={nobankRefundBankNm}/>
                                                                                            </div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-table-row'}>
                                                                                                <div
                                                                                                    className={'m-a-dep-charg-pg-table-item label'}>{t(`dcAcctNum`)}</div>
                                                                                                <input
                                                                                                    className={'m-a-dep-charg-pg-table-input'}
                                                                                                    maxLength={25}
                                                                                                    type="tel"
                                                                                                    onChange={handleNobankRefundAccount}
                                                                                                    value={nobankRefundAccount}
                                                                                                    inputMode={"numeric"}
                                                                                                    pattern={"[0-9]*"}/>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className={'m-a-dep-charg-pg-buttons'}>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-button-outline'}
                                                                                                onClick={nobankRefundInit}>{t(`dcInitBt`)}</div>
                                                                                            <div
                                                                                                className={'m-a-dep-charg-pg-button-fill'}
                                                                                                onClick={saveNobankRefund}
                                                                                                style={{pointerEvents: submitBtDisabled ? 'none' : 'auto'}}>{t(`dcDoneBt`)}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : null}
            </div>
            {paypalPopupSt && (
                <PaypalModal paypalPopupSt={paypalPopupSt} paypalPopupClose={paypalPopupClose}
                             currency={selectedDollar}
                             finalPayExpense={paypalChargePrice} lastForPrice={paypalChargeExPrice}
                             afterOrderProcess={savePaypalCharge}/>
            )}

            {
                btorageGlobalPopupSt ?
                    <BtorageGlobalModal btorageGlobalPopupSt={btorageGlobalPopupSt}
                                        closeBtorageGlobalPopup={closeBtorageGlobalPopup}
                                        currency={selectedDollar} mbNum={memberInfo.mbNum}
                                        finalPayExpense={btorageGlobalChargePrice}
                                        lastForPrice={btorageGlobalChargeExPrice}
                                        afterOrderProcess={saveBtorageGlobalCharge}/>
                    :
                    btorageKoreanPopupSt ?
                        <BtorageKoreanModal btorageKoreanPopupSt={btorageKoreanPopupSt}
                                            closeBtorageKoreanPopup={closeBtorageKoreanPopup}
                                            mbNum={memberInfo.mbNum}
                                            finalPayExpense={btorageKoreanChargePrice}
                                            afterOrderProcess={saveBtorageKoreanCharge}/>
                        :
                        globalCardPopupSt ?
                            <GlobalCardModal globalCardPopupSt={globalCardPopupSt}
                                             closeGlobalCardPopup={closeGlobalCardPopup}
                                             currency={selectedDollar} mbNum={memberInfo.mbNum}
                                             finalPayExpense={globalCardChargePrice}
                                             lastForPrice={globalCardChargeExPrice}
                                             afterOrderProcess={saveGlobalCardCharge}/>
                            :
                            koreanPayPopupSt ?
                                <KoreanPayModal koreanPayPopupSt={koreanPayPopupSt}
                                                closeKoreanPayPopup={closeKoreanPayPopup}
                                                mbNum={memberInfo.mbNum}
                                                finalPayExpense={koreanPayChargePrice}
                                                afterOrderProcess={saveKoreanPayCharge}/>
                                :
                                fieldEmptyError ?
                                    <MsgCheckModal fieldEmptyError={fieldEmptyError}
                                                   closeFieldEmptyError={closeFieldEmptyError}/>
                                    :
                                null
            }

        </div>
    )
}

export default withAuth(MDepChargePg);
